export default __webpack_public_path__ + "static/TitilliumWeb-Regular-27df57d9189d422f2fbcd29e0870875c.woff2";